"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reduxActions = require("redux-actions");

var _contents = require("../utils/contents");

var _actions = require("../actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  // raw data
  topics: null,
  folders: null,
  publications: null,
  videos: null,
  // timestamp to check data actuality
  contentsUpdated: null,
  // indexes TODO: get rid of indexes and use memoized selectors for computing derived data
  foldersIndex: null,
  videosIndex: null,
  contentIndex: null,
  // assets
  currentAsset: null,
  currentLocalAsset: null,
  assetMap: {},
  localAssetMap: {},
  heroShots: null,
  heroShotMap: {},
  imageMaps: null,
  imageMapBlobs: null,
  // content download for offline use
  fetchingContentBundle: false,
  contentBundleProgress: null,
  contentBundleError: null,
  // loading indicators
  fetching: false,
  fetchingAsset: false,
  fetchingLocalAsset: false,
  fetchingImageMaps: false,
  fetchingUpdates: false,
  // errors
  error: null,
  errorAsset: null,
  errorLocalAsset: null,
  errorImageMap: null,
  errorSearch: null,
  errorUpdates: null,
  // search state
  searchQuery: "",
  searchTopics: null,
  searchFolders: null,
  // timestamp to check data actuality
  searchContentsUpdated: null,
  // navigation
  currentFolder: null,
  // offline content updates TODO: get rid of this flag and use memoized selector for computing derived data
  updatesAvailable: false,
  searchPagesByPublication: {}
};

function contentsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.FLUSH_CONTENTS:
      state.imageMapBlobs && Object.entries(state.imageMapBlobs).map(function (x) {
        return (0, _contents.freeBlobResource)(x);
      }); // TODO: side effect in reducer, not good

      return _objectSpread(_objectSpread({}, state), {}, {
        topics: null,
        folders: null,
        publications: null,
        videos: null,
        imageMapBlobs: null,
        imageMaps: null,
        currentFolder: null,
        error: null,
        searchQuery: "",
        searchTopics: null,
        searchFolders: null,
        localAssetMap: {},
        assetMap: {},
        updatesAvailable: false,
        heroShots: null,
        contentsUpdated: null,
        searchContentsUpdated: null
      });

    case _actions.GET_CONTENTS_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        topics: null,
        videos: null,
        fetching: true,
        error: null
      });

    case _actions.GET_CONTENTS_CANCEL:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: false
      });

    case _actions.GET_CONTENTS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        topics: null,
        fetching: false,
        error: action.payload
      });

    case _actions.GET_CONTENTS_SUCCESS:
      return (0, _contents.processLoadedContent)(state, action.payload);

    case _actions.GET_CONTENTS_DOWNLOAD_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        contentBundleProgress: null,
        fetchingContentBundle: true,
        contentBundleError: null
      });

    case _actions.GET_CONTENTS_DOWNLOAD_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        contentBundleProgress: null,
        fetchingContentBundle: false,
        contentBundleError: null
      });

    case _actions.GET_CONTENTS_DOWNLOAD_PROGRESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        contentBundleProgress: action.payload
      });

    case _actions.GET_CONTENTS_DOWNLOAD_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        contentBundleProgress: null,
        fetchingContentBundle: false,
        contentBundleError: action.payload
      });

    case _actions.SEARCH_CONTENTS_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: true,
        errorSearch: null
      });

    case _actions.SEARCH_CONTENTS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: false,
        errorSearch: action.payload
      });

    case _actions.SEARCH_CONTENTS_CANCEL:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: false,
        errorSearch: null
      });

    case _actions.SEARCH_CONTENTS_SUCCESS:
      return (0, _contents.processLoadedSearchContent)(state, action.payload);

    case _actions.SEARCH_RANKING_CONTENTS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: false,
        searchContents: action.payload,
        searchContentsUpdated: +new Date()
      });

    case _actions.GET_IMAGE_MAPS_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingImageMaps: true,
        imageMapBlobs: null
      });

    case _actions.GET_IMAGE_MAPS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingImageMaps: false,
        imageMapBlobs: action.payload
      });

    case _actions.GET_IMAGE_MAPS_CANCEL:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingImageMaps: false
      });

    case _actions.GET_IMAGE_MAPS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingImageMaps: false,
        errorImageMap: action.payload
      });

    case _actions.GET_ASSET_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentAsset: null,
        fetchingAsset: true,
        errorAsset: null
      });

    case _actions.GET_ASSET_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentAsset: action.payload,
        assetMap: _objectSpread(_objectSpread({}, state.assetMap), {}, _defineProperty({}, action.payload.objectKey, action.payload)),
        fetchingAsset: false,
        errorAsset: null
      });

    case _actions.GET_ASSET_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentAsset: null,
        fetchingAsset: false,
        errorAsset: action.payload
      });

    case _actions.GET_LOCAL_ASSET_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentLocalAsset: null,
        fetchingLocalAsset: true,
        errorLocalAsset: null
      });

    case _actions.GET_LOCAL_ASSET_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentLocalAsset: action.payload,
        localAssetMap: _objectSpread(_objectSpread({}, state.localAssetMap), {}, _defineProperty({}, action.payload.objectKey, action.payload)),
        fetchingLocalAsset: false,
        errorLocalAsset: null
      });

    case _actions.GET_LOCAL_ASSET_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentLocalAsset: null,
        fetchingLocalAsset: false,
        errorLocalAsset: action.payload
      });

    case _actions.GET_FILE_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentFile: null,
        fetchingFile: true,
        errorFile: null
      });

    case _actions.GET_FILE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentFile: action.payload,
        fetchingFile: false,
        errorFile: null
      });

    case _actions.GET_FILE_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentFile: null,
        fetchingFile: false,
        errorFile: action.payload
      });

    case _actions.GET_HEROSHOT_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingHeroShot: true,
        errorHeroShot: null
      });

    case _actions.GET_HEROSHOT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        heroShotMap: _objectSpread(_objectSpread({}, state.heroShotMap), {}, _defineProperty({}, action.payload.key, action.payload.url)),
        fetchingHeroShot: false,
        errorHeroShot: null
      });

    case _actions.GET_HEROSHOT_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingHeroShot: false,
        errorHeroShot: action.payload
      });

    case _actions.SET_SEARCH_QUERY:
      return _objectSpread(_objectSpread({}, state), {}, {
        searchQuery: action.payload,
        currentFolder: null,
        errorSearch: null
      });

    case _actions.CHECK_UPDATES_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingUpdates: true,
        updatesAvailable: false
      });

    case _actions.CHECK_UPDATES_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingUpdates: false,
        updatesAvailable: (0, _contents.isUpdateAvailable)(state.publications.toJS(), action.payload.publications)
      });

    case _actions.CHECK_UPDATES_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchingUpdates: false,
        updatesAvailable: false,
        errorUpdates: action.payload
      });

    default:
      return state;
  }
}

var searchPagesReducer = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _actions.SEARCH_CONTENTS_REQUEST, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    searchPagesByPublication: {}
  });
}), _defineProperty(_handleActions, _actions.getSearchPagesActions.request, function (state, _ref) {
  var publicationId = _ref.payload.publicationId;
  return _objectSpread(_objectSpread({}, state), {}, {
    searchPagesByPublication: _objectSpread(_objectSpread({}, state.searchPagesByPublication), {}, _defineProperty({}, publicationId, {
      isFetching: true,
      error: null,
      data: null
    }))
  });
}), _defineProperty(_handleActions, _actions.getSearchPagesActions.error, function (state, _ref2) {
  var _ref2$payload = _ref2.payload,
      publicationId = _ref2$payload.publicationId,
      error = _ref2$payload.error;
  return _objectSpread(_objectSpread({}, state), {}, {
    searchPagesByPublication: _objectSpread(_objectSpread({}, state.searchPagesByPublication), {}, _defineProperty({}, publicationId, {
      isFetching: false,
      error: error,
      data: null
    }))
  });
}), _defineProperty(_handleActions, _actions.getSearchPagesActions.success, function (state, _ref3) {
  var _ref3$payload = _ref3.payload,
      publicationId = _ref3$payload.publicationId,
      data = _ref3$payload.data;
  return _objectSpread(_objectSpread({}, state), {}, {
    searchPagesByPublication: _objectSpread(_objectSpread({}, state.searchPagesByPublication), {}, _defineProperty({}, publicationId, {
      isFetching: false,
      error: null,
      data: data
    }))
  });
}), _handleActions), initialState);

var _default = function _default(state, action) {
  var updatedState = searchPagesReducer(state, action);
  return contentsReducer(updatedState, action);
};

exports["default"] = _default;